import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { EmailSuivi, OptionsSuiviInterventionState } from './state';

export const getters: GetterTree<OptionsSuiviInterventionState, RootState> = {
    isSuiviActif(state): boolean {
        return state.suiviDI.actif;
    },
    emailsSuivi(state): EmailSuivi[] {
        return state.suiviDI.emailsSuivi;
    },
    isMaximumEmailActifReached(state): boolean {
        return state.suiviDI.emailsSuivi?.filter(e => e.actif).length >= 4;
    }
};
